"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[384,475],{

/***/ 6475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _Image__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4297);



/***/ }),

/***/ 8384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ulupinar_works_UlupinarWorks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/base/image/index.tsx
var base_image = __webpack_require__(6475);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/widgets/ulupinar-works/UlupinarWorks.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var UlupinarWorks = function(param) {
    var title = param.title, desc = param.desc, descImage = param.descImage;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ulupinar-works",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ulupinar-works-info",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "ulupinar-works-info-title",
                        children: title
                    }),
                    desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ulupinar-works-info-desc",
                        dangerouslySetInnerHTML: {
                            __html: desc
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ulupinar-works-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({
                        className: "full-image"
                    }, descImage, {
                        alt: ""
                    }))
                })
            })
        ]
    }));
};
/* harmony default export */ var ulupinar_works_UlupinarWorks = (UlupinarWorks);

;// CONCATENATED MODULE: ./components/widgets/ulupinar-works/index.ts



/***/ })

}]);